import * as DateFns from 'date-fns';

export const format = DateFns.format;
